import React from 'react';
import { Alert } from 'react-bootstrap';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

function ErrorFallbackComponent() {

    const navigate = useNavigate()

    const onHomeClick = () => {
        navigate('/dashboard')
    }
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <Result
        status="error"
        title="Oops! Something went wrong."
        subTitle="We apologize for the inconvenience. Please try again later."
        extra={[
        //   <Button type="primary" key="back" onClick={() => window.location.reload()}>
        //     Refresh Page
        //   </Button>,
          <Button key="home" onClick={onHomeClick}>
            Go to Home
          </Button>,
        ]}
      />
      <Alert variant="danger" style={{ marginTop: '20px' }}>
        An error occurred while loading the page. Please try refreshing the page or go back to the home page.
      </Alert>
    </div>
  );
}

export default ErrorFallbackComponent;
